import { pdfToBrowser } from './placement.utils.ts';
import type { BuildDropPreviewInput, DropPreview } from './PlacementOverlay.types.ts';

/** Equal by value, so a drag move that changes nothing does not re-render the overlay. */
export const sameDropPreview = (a: DropPreview | null, b: DropPreview | null): boolean =>
	a?.key === b?.key &&
	a?.landing?.left === b?.landing?.left &&
	a?.landing?.top === b?.landing?.top &&
	a?.landing?.width === b?.landing?.width &&
	a?.landing?.height === b?.landing?.height;

/** The preview for a blocked drop, offset into the source overlay; null while the drop is free. */
export const buildDropPreview = ({
	key,
	landing,
	pages,
	sourcePageNum,
	scale,
}: BuildDropPreviewInput): DropPreview | null => {
	const source = pages.find((page) => page.pageNum === sourcePageNum);
	const target = pages.find((page) => page.pageNum === landing?.pageNum);
	if (!landing?.isBlocked || !source || !target) {
		return null;
	}
	if (!landing.landing) {
		return { key, landing: null };
	}
	const onTarget = pdfToBrowser(landing.landing, target.dims.heightPt, scale);
	return {
		key,
		landing: {
			...onTarget,
			left: onTarget.left + target.rect.left - source.rect.left,
			top: onTarget.top + target.rect.top - source.rect.top,
		},
	};
};
